var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.17 29.34C13.5652 29.34 11.0189 28.5676 8.85315 27.1205C6.68735 25.6733 4.99932 23.6164 4.00251 21.2099C3.00571 18.8034 2.7449 16.1554 3.25306 13.6007C3.76123 11.0459 5.01555 8.69927 6.85741 6.85741C8.69927 5.01555 11.0459 3.76123 13.6007 3.25306C16.1554 2.7449 18.8034 3.00571 21.2099 4.00251C23.6164 4.99932 25.6733 6.68735 27.1205 8.85315C28.5676 11.0189 29.34 13.5652 29.34 16.17C29.3347 19.6613 27.9455 23.0081 25.4768 25.4768C23.0081 27.9455 19.6613 29.3347 16.17 29.34ZM16.17 5.00001C13.9608 5.00001 11.8012 5.65511 9.96429 6.88249C8.12739 8.10987 6.6957 9.85438 5.85027 11.8954C5.00484 13.9365 4.78364 16.1824 5.21463 18.3492C5.64563 20.5159 6.70947 22.5062 8.27162 24.0684C9.83378 25.6305 11.8241 26.6944 13.9908 27.1254C16.1576 27.5564 18.4035 27.3352 20.4446 26.4897C22.4856 25.6443 24.2301 24.2126 25.4575 22.3757C26.6849 20.5388 27.34 18.3792 27.34 16.17C27.3374 13.2084 26.1597 10.3688 24.0655 8.27455C21.9713 6.18034 19.1317 5.00265 16.17 5.00001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.84 21.51C13.7084 21.5107 13.578 21.4855 13.4561 21.4358C13.3343 21.386 13.2235 21.3127 13.13 21.22L8.79004 16.88L10.17 15.46L13.81 19.1L21.42 11.48L22.83 12.9L14.51 21.22C14.3312 21.3976 14.0919 21.5012 13.84 21.51Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.35,
    height: 26.35,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheckCircle);
export default __webpack_public_path__ + "static/media/StatusCheckCircle.3b372fd2.svg";
export { ForwardRef as ReactComponent };